<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-assign-excercise" @hidden="resetModal">
            <div class="container modal-assign-excercise">
                <h4 class="title-header">
                    <strong>Giao bài</strong>
                </h4>
                <h5>
                    <strong>Thời gian</strong>
                </h5>
                <div class="form-group p-3 ">
                    <div class=" row wrap-time">
                        <div class="row col-md-12">
                            <div class="col-md-6">
                                <div class="title-time-start">
                                    <strong>Giờ bắt đầu</strong>
                                </div>
                                <div class="display-flex">
                                    <input class="input-time" type="number" v-model="hoursStart"
                                        @input="validateHourStart" /> : <input class="input-time minute" type="number"
                                        v-model="timeStart" @input="validateTimeStart" />
                                    <span class="display-flex">
                                        <!-- <div class="mode" :class="{'light':modeStart==1}">Sáng</div><div class="mode" :class="{'light':modeStart==2}">Tối</div> -->
                                    </span>
                                </div>

                            </div>
                            <div class="col-md-6">
                                <div class="title-time-start">
                                    <strong>Giờ kết thúc</strong>
                                </div>
                                <div class="display-flex">
                                    <input class="input-time" v-model="hoursEnd" @change="validateHourEnd" /> : <input
                                        class="input-time minute" type="number" v-model="timeEnd"
                                        @input="validateTimeEnd" />
                                    <span class="display-flex">
                                        <!-- <div class="mode" :class="{'light':modeEnd==1}">Sáng</div><div class="mode" :class="{'light':modeEnd==2}">Tối</div> -->
                                    </span>
                                </div>

                            </div>
                        </div>
                        <div class="row  col-md-12">
                            <div class="col-md-12">
                                <strong>Ngày</strong>
                            </div>
                            <div class="col-md-12">
                                <date-range-picker v-model="dateRange">
                                </date-range-picker>
                            </div>
                        </div>
                    </div>




                    <div class="row mt-10">
                        <h5>
                            <strong>Chọn lớp</strong>
                        </h5>
                    </div>
                    <div class="wrap-list-class-group">
                        <div class="row item-class-group" v-for="(item, index) of listData" :key="index">
                            <div class="col-md-2">
                                <b-form-checkbox v-model="item.isCheck"
                                    @change="handleClearCheckGroupChild(item)"></b-form-checkbox>
                                <!-- </b-form-checkbox> -->
                            </div>
                            <div class="col-md-10">
                                <div class="row">
                                    <div class="col-md-12">
                                        <strong class="name-class" @click="handleToggerGroup(item)">{{ item.name
                                            }}</strong>
                                        <i v-if="item.listGroupClassSchool.length > 0"
                                            class="icon-arrow-down icon-down"></i>
                                    </div>
                                </div>

                            </div>
                            <div v-if="item.isCollapse" class="col-md-12">
                                <div class="row" v-for="(group, index) of item.listGroupClassSchool" :key="index">
                                    <div class="col-md-2">
                                    </div>
                                    <div class="col-md-10">
                                        <div class="row">
                                            <div class="col-md-2">
                                                <b-form-checkbox v-model="group.isCheck"
                                                    :disabled="item.isCheck ? true : false">
                                                </b-form-checkbox>
                                            </div>
                                            <div class="col-md-10">
                                                {{ group.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form_action display-flex justity-content-center">
                        <button type="button" @click="handleHideModal"
                            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading">
                            Hủy
                        </button>
                        <button type="button" @click="handleAssignClassSchool"
                            class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isDisabled">
                            Giao bài
                        </button>
                    </div>
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
import { assignLessonClassSchool } from './../../../_api/LessonClassSchoolServices'
import { getListClassAndGroupByTeacherIdAssign } from './../../../_api/classSchoolServices'
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
export default {
    name: "ModalAssignExcercise",
    props: {
        item:{
            type:Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default:{}
        },
        type: {
            type: Number,
            default: 0
        },
    },
    components: {
        DateRangePicker
    },
    data() {
        let startDate = new Date();
        let endDate = new Date();
        endDate.setDate(endDate.getDate() + 6)
        return {
            isDisabled:false,
            confirmActive: {},
            submitted: false,
            isLoading: false,
            dateRange: {startDate, endDate},
            hoursStart:'',
            timeStart:'',
            hoursEnd:'',
            timeEnd:'',
            modeStart:0,
            modeEnd:0,
            listData: [],
            listClassGroup:[],
            optionsDate:{
                direction: 'vi',
            }
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },

    },
    mounted() {
        this.getListClassAndGroup()
        this.setTime()
        this.handleShowModal()
    },
    watch:{
        'dateRange.endDate':'validateTimeAssign'
    },
    methods: {
        handleClearCheckGroupChild(item){
            for (let i = 0; i < item.listGroupClassSchool.length; i++) {
                let group = item.listGroupClassSchool[i];
                group.isCheck = false
            }
        },
        setTime () {
            const d = new Date()
            if (d.getHours() < 10) {
                this.hoursStart = `0${d.getHours()}`;
                this.hoursEnd = `0${d.getHours()}`;
            } else {
                this.hoursStart = d.getHours().toString();
                this.hoursEnd = d.getHours().toString();
            }

            if (d.getMinutes() < 10) {
                this.timeStart = `0${d.getMinutes()}`;
                this.timeEnd = `0${d.getMinutes()}`;
            } else {
                this.timeStart = d.getMinutes().toString();
                this.timeEnd = d.getMinutes().toString();
            }


        },
        validateTimeAssign(){
            this.validateHourEnd()
            this.validateTimeEnd()
        },
        validateTimeEnd(){
            let inputNum = parseInt(this.timeEnd);
            
            // Điều chỉnh giá trị đầu vào
            if (isNaN(inputNum) || inputNum < 0) {
                inputNum = 0;
            } else if (inputNum > 59) {
                inputNum = 59;
            }

            if(inputNum<Number(this.timeStart) && this.dateRange.startDate.getTime() == this.dateRange.endDate.getTime() && Number(this.hoursEnd) == Number(this.hoursStart)){
                inputNum = Number(this.timeStart)
            }
            
            // Định dạng giá trị đầu vào
            if (inputNum < 10) {
                this.timeEnd = `0${inputNum}`;
            } else {
                this.timeEnd = inputNum.toString();
            }
        },
        validateTimeStart(){
            let inputNum = parseInt(this.timeStart);
            
            // Điều chỉnh giá trị đầu vào
            if (isNaN(inputNum) || inputNum < 0) {
                inputNum = 0;
            } else if (inputNum > 59) {
                inputNum = 59;
            }
            if (inputNum > Number(this.timeEnd) && this.dateRange.startDate.getTime() == this.dateRange.endDate.getTime() && Number(this.hoursEnd) == Number(this.hoursStart)) {
                inputNum = Number(this.timeEnd)
            }
            // Định dạng giá trị đầu vào
            if (inputNum < 10) {
                this.timeStart = `0${inputNum}`;
            } else {
                this.timeStart = inputNum.toString();
            }
        },
        validateHourEnd(){
            let inputNum = parseInt(this.hoursEnd);
            
            // Điều chỉnh giá trị đầu vào
            if (isNaN(inputNum) || inputNum < 0) {
                inputNum = 0;
            } else if (inputNum > 23) {
                inputNum = 23;
            }
            if (inputNum - Number(this.hoursStart) < 2 && this.dateRange.startDate.getTime() == this.dateRange.endDate.getTime()) {
                inputNum = Number(this.hoursStart)
                if (inputNum <= 21) {
                    inputNum += 2
                }
                else {
                    inputNum = inputNum - 24 + 2
                    this.dateRange.endDate = new Date(this.dateRange.endDate.setDate(this.dateRange.endDate.getDate() + 1)) 
                }
            }
            // if(inputNum<18){
            //     this.modeEnd =1
            // } 
            // else{
            //     this.modeEnd =2
            // }
            // Định dạng giá trị đầu vào
            if (inputNum < 10) {
                this.hoursEnd = `0${inputNum}`;
            } else {
                this.hoursEnd = inputNum.toString();
            }
        },
        validateHourStart(){
            let inputNum = parseInt(this.hoursStart);
            
            // Điều chỉnh giá trị đầu vào
            if (isNaN(inputNum) || inputNum < 0) {
                inputNum = 0;
            } else if (inputNum > 23) {
                inputNum = 23;
            }
            if(Number(this.hoursEnd) - inputNum < 2 &&this.dateRange.startDate.getTime() == this.dateRange.endDate.getTime()){
                inputNum = Number(this.hoursEnd)
                if (inputNum > 2) {
                    inputNum -= 2
                }
                else {
                    inputNum = inputNum + 24 - 2
                    this.dateRange.startDate = new Date(this.dateRange.startDate.setDate(this.dateRange.startDate.getDate() - 1)) 
                }
            }

            // Định dạng giá trị đầu vào
            if (inputNum < 10) {
                this.hoursStart = `0${inputNum}`;
            } else {
                this.hoursStart = inputNum.toString();
            }
        },
        getListClassAndGroup(){
            this.listClassGroup = []
            getListClassAndGroupByTeacherIdAssign({lessonClassSchoolId:this.item.id,type:this.type, subjectId: this.item.subjectId}).then(res => {
                if (res && res.data && !res.errors) {
                    this.listClassGroup = res.data

                    this.listData = []
                    for (let i = 0; i < this.listClassGroup.length; i++) {
                        const item = this.listClassGroup[i];
                        let itemAdd = { id: item.id, name: item.name, isCheck: false, listGroupClassSchool: [], isCollapse: false }
                        if (item.listGroupClassSchool.length > 0) {
                            for (let j = 0; j < item.listGroupClassSchool.length; j++) {
                                const group = item.listGroupClassSchool[j];
                                itemAdd.listGroupClassSchool.push({ id: group.id, name: group.name, isCheck: false })
                            }
                        }
                        this.listData.push(itemAdd)
                    }
                }
            })
        },
        handleToggerGroup(item) {
            item.isCollapse = !item.isCollapse
        },
        handleAssignClassSchool(){
            // if(!this.item.isPublic){
            //     this.$toast.error(`Bạn chưa chuyển bài giảng điện tử ${this.item.name} về công khai`)
            //     return
            // }
            
            if(!this.hoursStart){
                this.hoursStart = '00'
            }
            if(!this.timeStart){
                this.timeStart = '00'
            }
            let dayStart = this.dateRange.startDate.getDate()
            if(dayStart<10){
                dayStart = '0'+dayStart
            }

            let monthStart = this.dateRange.startDate.getMonth()
            if(monthStart<10){
                monthStart = '0'+(monthStart+1)
            }

            let dateTimeStart = `${monthStart}/${dayStart}/${this.dateRange.startDate.getFullYear()} ${this.hoursStart}:${this.timeStart}:00`

            const dateObjStart = new Date(dateTimeStart);

            const isoDateTimeStringStart = dateObjStart.toISOString();


            if(!this.hoursEnd){
                this.hoursEnd = '00'
            }
            if(!this.timeEnd){
                this.timeEnd = '00'
            }
            let dayEnd = this.dateRange.endDate.getDate()
            if(dayEnd<10){
                dayEnd = '0'+dayEnd
            }

            let monthEnd = this.dateRange.endDate.getMonth()
            if(monthEnd<10){
                monthEnd = '0'+(monthEnd+1)
            }

            let dateTimeEnd = `${monthEnd}/${dayEnd}/${this.dateRange.endDate.getFullYear()} ${this.hoursEnd}:${this.timeEnd}:00`

            const dateObjEnd = new Date(dateTimeEnd);

            const isoDateTimeStringEnd = dateObjEnd.toISOString();

            let listClassSchool = []
            for (let i = 0; i < this.listData.length; i++) {
                const item = this.listData[i];
                if(item.isCheck){
                    listClassSchool.push(item.id)
                }
            }
            let listGroupClassSchool = []
            for (let i = 0; i < this.listData.length; i++) {
                const item = this.listData[i];
                for (let j = 0; j < item.listGroupClassSchool.length; j++) {
                    const group = item.listGroupClassSchool[j];
                    if(group.isCheck){
                        listGroupClassSchool.push(group.id)
                    }
                }
            }
            if(listClassSchool.length == 0 && listGroupClassSchool.length == 0){
                this.$toast.error('Vui lòng chọn lớp hoặc nhóm cần giao')
                return 
            }
            let data={
                listClassSchool:listClassSchool,
                listGroupClassSchool:listGroupClassSchool,
                type:this.type,
                lessonClassSchoolId:this.item.id,
                timeAssignStart:isoDateTimeStringStart,
                timeAssignEnd:isoDateTimeStringEnd,
            }
            this.isDisabled = true
            assignLessonClassSchool(data).then((res) => {
                if (res && res.data && !res.errors) {
                    this.$toast.success('Giao bài giảng thành công')
                    this.handleDone()
                }
                this.isDisabled = true
            })
        },
        
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },

        resetModal() {
            console.log('resetModal')
            this.submitted = false
            this.form = {
                userName: '',
            }
        },
        toggleModal() {
            
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-assign-excercise'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-assign-excercise'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-assign-excercise'].show()
        },
        
    }
}
</script>

<style>
.reportrange-text {
    border: 2px solid #57b1f3 !important;
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #c1c1c1;
}
</style>
<style lang="scss" scoped>
.modal-assign-excercise{
    background-color: white
}
.mt-10{
    margin-top: 10px;
}
.wrap-time {
    padding-bottom: 20px;
    border-bottom: 1px solid #cccccc;
}

.minute {
    background: #ececec;
}

.title-header {

    padding-bottom: 20px;
    border-bottom: 1px solid #cccccc;
}

.justity-content-center {
    justify-content: center;
}

.modal_body {
    background-color: white;
}

.light {
    width: 50px;
    height: 27px;
    border-radius: 5px;
    border: 1px solid #0091ee !important;
    text-align: center;
    background-color: #0091ee !important;
    color: white !important;
}

.mode {
    width: 50px;
    height: 27px;
    background-color: white;
    border-radius: 5px;
    border: 1px solid #d9d5d5;
    text-align: center;
}

.vue-daterange-picker {
    width: 100%;

    .reportrange-text {
        border: 2px solid #57b1f3 !important;
    }
}

.input-time {
    width: 50px;
    border: 2px solid #57b1f3;
    border-radius: 5px;
}

.item-class-group {
    width: 90%;
}

.name-class {
    cursor: pointer;
}

.icon-down {
    color: black !important;
    cursor: pointer;
    margin-left: 15px;
    font-size: 10px;
}

.wrap-list-class-group {
    max-height: 15rem;
    overflow: auto;
}
</style>